import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('opacity-100', 'translate-y-0');
          el.classList.remove('opacity-0', 'translate-y-8');
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20theater%20stage%20with%20warm%20spotlight%20beams%20cutting%20through%20darkness%2C%20geometric%20shapes%20floating%20in%20amber%20and%20coral%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20quality%2C%20soft%20glow%20effects%2C%20professional%20composition%2C%20clean%20dark%20background%20with%20warm%20light%20accents&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="吃瓜视频 - 独家爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div
            ref={titleRef}
            className="flex-1 text-center lg:text-left opacity-0 translate-y-8 transition-all duration-700 ease-out"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/20 border border-primary-500/30 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium">每日更新 · 独家爆料</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              全网独家
              <br />
              <span className="text-primary-400">吃瓜爆料视频</span>
            </h1>
            <p className="text-background-200 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              网红翻车、明星八卦一触即发！免费吃瓜视频每日刷新，
              国产黑料、反差视频持续更新。即刻点击，吃瓜吃到饱！
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/remen-baoliao"
                className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer group"
              >
                立即吃瓜
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
              </Link>
              <Link
                to="/category/wanghong-fanche"
                className="flex items-center gap-2 px-6 py-3 border border-background-300/50 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                网红翻车专区
              </Link>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <div className="aspect-[4/3] rounded-3xl overflow-hidden border border-background-200/20 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20video%20player%20interface%20with%20warm%20coral%20and%20amber%20gradient%20overlay%2C%20modern%20minimalist%20design%2C%20floating%20geometric%20elements%2C%20cinematic%20atmosphere%2C%20soft%20glow%20effects%2C%20editorial%20quality%2C%20dark%20background%20with%20warm%20accents&width=800&height=600&seq=hero-side-01&orientation=landscape"
                  alt="吃瓜视频播放界面"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-background-950 rounded-2xl p-4 border border-background-200/10 backdrop-blur-md">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full">
                    <i className="ri-play-fill text-background-50 text-lg"></i>
                  </span>
                  <div>
                    <p className="text-background-50 text-sm font-semibold">正在热播</p>
                    <p className="text-background-400 text-xs">2,380万次播放</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}